export const firstEnterUrl = location.href  // 首次进入url，苹果搜索用此链接作jsSdk签名
export const UA = window.navigator.userAgent.toLowerCase()
export const isIOS = UA && /iphone|ipad|ipod|ios/.test(UA)
export let hitTab = {
  user: false
}



// WEBPACK FOOTER //
// ./src/api/global.js